import DateFormat from 'date-fns/format';
import DifferenceInDays from 'date-fns/difference_in_calendar_days';
import DifferenceInYears from 'date-fns/difference_in_years';
import SubYears from 'date-fns/sub_years';
import AddDays from 'date-fns/add_days';
import AddYears from 'date-fns/add_years';
import SubDays from 'date-fns/sub_days';
import ParseString from 'date-fns/parse';
import IsValid from 'date-fns/is_valid';
import IsAfter from 'date-fns/is_after';
import IsBefore from 'date-fns/is_before';

class DateManager {
  /**
   * The constructor
   */
  constructor() {
    this.driverAge = null;
  }

  /**
   * Check to see if the first date is after the second date
   *
   * @param first
   * @param second
   * @returns {boolean}
   */
  isAfter(first, second) {
    return IsAfter(first, second);
  }

  /**
   * Check to see if the first date is before the second date
   *
   * @param first
   * @param second
   * @returns {boolean}
   */
  isBefore(first, second) {
    return IsBefore(first, second);
  }

  /**
   * Parse the given date string to a date object
   * @param date
   * @returns {Date}
   */
  parse(date) {
    if (typeof date === 'string') {
      return ParseString(date);
    }

    return date;
  }
  /**
   * Format the date
   *
   * @param value
   * @param format
   */
  format(value, format = 'DD/MM/YYYY') {
    if (!value) {
      return 'Not available';
    }
    return DateFormat(value, format);
  }

  /**
   * Calculate the difference in days
   *
   * @param left
   * @param right
   * @returns {number}
   */
  differenceInDays(left, right) {
    return DifferenceInDays(left, right);
  }

  /**
   * Add the given number of days to the date
   *
   * @param start
   * @param years
   * @returns {Date}
   */
  addDays(start, days) {
    return AddDays(start, days);
  }

  /**
   * Add a day to the date
   *
   * @param start
   * @returns {Date}
   */
  addDay(start) {
    return AddDays(start, 1);
  }

  /**
   * Calculate the difference in years
   *
   * @param left
   * @param right
   * @returns {number}
   */
  differenceInYears(left, right) {
    return DifferenceInYears(left, right);
  }

  /**
   *
   * Add the given number of years to the date
   *
   * @param start
   * @param years
   * @returns {Date}
   */
  addYears(start, years) {
    return AddYears(start, years);
  }

  /**
   *
   * Add a year to the given date
   *
   * @param start
   * @returns {Date}
   */
  addYear(start) {
    return this.addYears(start, 1);
  }

  /**
   *
   * Subtract the given number of years
   *
   * @param start
   * @param years
   * @returns {Date}
   */
  subtractYears(start, years) {
    return SubYears(start, years);
  }

  /**
   *
   * Subtract the given number of days
   *
   * @param start
   * @param days
   * @returns {Date}
   */
  subtractDays(start, days) {
    return SubDays(start, days);
  }

  /**
   *
   * Subtract one day
   *
   * @param start
   * @returns {Date}
   */
  subtractDay(start) {
    return SubDays(start, 1);
  }

  /**
   * Check to see if the current date is valid
   *
   * @param date
   * @returns {boolean}
   */
  isValid(date) {
    return IsValid(date);
  }

  /**
   * Get the starting date for new drivers
   */
  driverStartingDate() {
    if (!this.driverAge) {
      this.driverAge = this.subtractYears(new Date(), 16);
    }

    return this.driverAge;
  }
}

export default DateManager;
